import html2canvas from "html2canvas-pro";
import { jsPDF } from "jspdf";

/**
 * Renders a DOM element (the chat message area) to a multi-page A4 PDF that
 * looks exactly like what's on screen — bubbles, gradients, markdown tables,
 * charts, etc. Uses html2canvas-pro so Tailwind 4 `oklch` colors are supported.
 */
export const exportChatToPdf = async (
  element: HTMLElement,
  fileName = "T-Rex-Chat.pdf"
): Promise<void> => {
  const canvas = await html2canvas(element, {
    scale: 2,
    backgroundColor: "#f9fafb",
    height: element.scrollHeight,
    windowHeight: element.scrollHeight,
  });

  const imgData = canvas.toDataURL("image/png");
  const pdf = new jsPDF({ unit: "pt", format: "a4" });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const imgWidth = pageWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = 0;

  pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
  heightLeft -= pageHeight;

  // Slice the tall image across as many A4 pages as needed.
  while (heightLeft > 0) {
    position -= pageHeight;
    pdf.addPage();
    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  }

  pdf.save(fileName);
};
